import { tw } from "@/utils";
import { PreKtasLabel } from "@/components/PreKtasLabel/PreKtasLabel";
import { useNavigate, useParams } from "react-router";
import { TransferRequest } from "./api";
import { getAgeFromBirthDate } from "@/components/PatientInfo/PatientInfoCard/utils";
import { convertChiefComplaints } from "@/data/symptom";
import { codeToName } from "@/data/codes";
import dayjs from "dayjs";

interface PatientListCardProps {
  data: TransferRequest;
}

export const PatientListCard = (props: PatientListCardProps) => {
  const { data } = props;
  const params = useParams();
  const navigate = useNavigate();

  return (
    <div
      className={tw(
        "w-full h-fit bg-white",
        "border-solid border-[1px] border-gray-g30 rounded-[8px] cursor-pointer",
        data.requestId === params.requestId && "border-purple-100"
      )}
      onClick={() => {
        navigate(`/transferring/${data.requestId}`);
      }}
    >
      <div
        className={tw(
          "flex items-center w-full h-[56px] p-[16px] pb-[12px]",
          "border-solid border-b-[1px] border-gray-g30"
        )}
      >
        <div className="text-xl font-semibold text-gray-g500">
          {data.patientName}
        </div>
        <div className="text-base font-regular text-gtay-g200 ml-[10px]">
          {getAgeFromBirthDate(data.birthDt)
            ? `만 ${getAgeFromBirthDate(data.birthDt)}세`
            : "나이 정보 없음"}
        </div>
        <div
          className={tw(
            "ml-auto flex items-center justify-center w-[76px] h-[28px] rounded-[20px] bg-[#FF6D57]/8",
            "text-sm font-semibold text-[#FF6D57]",
            "border-solid border-b-[1px] border-gray-g30"
          )}
        >
          {data.transferType}
        </div>
      </div>
      <div className="w-full h-[calc(100%-56px)] p-[16px] pt-[12px]">
        <div className="flex flex-col gap-[18px]">
          <div className="flex items-center justify-between w-full h-[24px]">
            <div className={tw(titleFontStyle)}>주호소</div>
            <div className="flex items-center gap-[10px]">
              <div className={tw(contentsFontStyle)}>
                {convertChiefComplaints(data.chiefComplaint)}
              </div>
              <PreKtasLabel preKtas={data.preKtas} />
            </div>
          </div>
          <div className="flex items-center justify-between w-full h-[24px]">
            <div className={tw(titleFontStyle)}>이송기관</div>
            <div className={tw(contentsFontStyle)}>
              <span>{data.managerName}</span>
              <span className="text-gray-g75">{" ㅣ "}</span>
              <span>
                {data.managerPhone ? data.managerPhone : "연락처 정보없음"}
              </span>
            </div>
          </div>
          <div className="flex items-center justify-between w-full h-[24px]">
            <div className={tw(titleFontStyle)}>예상도착시간</div>
            <div className={tw(contentsFontStyle)}>
              {data.arrivalTime
                ? dayjs(data.arrivalTime).format("YYYY-MM-DD HH:mm")
                : "정보 없음"}
            </div>
          </div>
          {/* <div className="flex items-center justify-between w-full h-[24px]">
            <div className={tw(titleFontStyle)}>담당 의료진</div>
            <div className={tw(contentsFontStyle)}>
              <span>순환기내과</span>
              <span>{" ㅣ "}</span>
              <span>박무강</span>
            </div>
          </div> */}
        </div>
        <div className="w-full h-[1px] bg-gray-g30 my-[12px]" />
        <div className="flex flex-wrap gap-[6px] w-full h-fit min-h-[28px]">
          {data.requiredResources.map((resource) => (
            <div
              className={tw(
                "flex items-center w-fit h-[28px] px-[10px] bg-purple-100/6",
                "border-solid border-[1px] border-purple-100 rounded-full",
                "text-sm font-medium text-gray-g500"
              )}
            >
              {
                codeToName[resource].split("] ")[
                  codeToName[resource].split("] ").length - 1
                ]
              }
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const titleFontStyle = tw("text-base font-medium text-gray-g100");
const contentsFontStyle = tw("text-base font-semibold text-gray-g300");
